import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'excel-file-icon',
  templateUrl: './excel-file-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ExcelFileIconComponent {}
